var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"print-offer max-height"},[_c('button',{class:{'disabledPrint': _vm.disabledPrint},attrs:{"disabled":_vm.disabledPrint},on:{"click":_vm.fetchOffer}},[_vm._v(_vm._s(_vm._f("translate")('print')))])])}
var staticRenderFns = []

export { render, staticRenderFns }